import { MockLOV } from '@/types';
import { ReservationHistory_PaymentStatus } from './store';

export const ReservationHistory_PaymentStatus_LOV: MockLOV[] = [
  {
    id: 1,
    code: ReservationHistory_PaymentStatus.PENDING,
    nameen: 'Pending payment',
    namevi: 'Chưa thanh toán',
  },
  {
    id: 2,
    code: ReservationHistory_PaymentStatus.COMPLETED,
    nameen: 'Payment successful',
    namevi: 'Thanh toán thành công',
  },
  {
    id: 3,
    code: ReservationHistory_PaymentStatus.FAILED,
    nameen: 'Payment failed',
    namevi: 'Thanh toán thất bại',
  },
  {
    id: 4,
    code: ReservationHistory_PaymentStatus.REFUNDED,
    nameen: 'Deposit refunded',
    namevi: 'Đã hoàn cọc',
  },
  {
    id: 5,
    code: ReservationHistory_PaymentStatus.EXPIRED,
    nameen: 'Payment expired',
    namevi: 'Hết hạn thanh toán',
  },
  {
    id: 6,
    code: ReservationHistory_PaymentStatus.CANCELLED,
    nameen: 'Payment cancelled',
    namevi: 'Hủy thanh toán',
  },
];

export const ReservationHistory_ApproveStatus_LOV: MockLOV[] = [
  {
    id: 1,
    code: 'PendingApprove',
    nameen: 'Pending approval',
    namevi: 'Chờ phê duyệt',
  },
  {
    id: 2,
    code: 'Approved',
    nameen: 'Approved',
    namevi: 'Duyệt thành công',
  },
  {
    id: 3,
    code: 'PaymentRejected',
    nameen: 'Rejected',
    namevi: 'Từ chối',
  },
  {
    id: 4,
    code: 'Cancelled',
    nameen: 'Cancelled',
    namevi: 'Đã hủy',
  },
];

export const getMockLOVDisplayValue = (
  language: string,
  currentKey?: string | number,
  list: MockLOV[] = ReservationHistory_PaymentStatus_LOV,
) => {
  if (currentKey === undefined || currentKey === null || currentKey === '') {
    return '';
  }

  const matchedItem = list.find(
    item =>
      `${item.code}`.toLowerCase() === `${currentKey}`.toLowerCase() ||
      `${item.id}` === `${currentKey}`,
  );

  if (!matchedItem) return `${currentKey}`;

  const normalizedLanguage = `${language || 'vi'}`.toLowerCase();
  const languageKey = `name${normalizedLanguage}` as keyof MockLOV;
  const displayValue =
    matchedItem[languageKey] ?? matchedItem.namevi ?? matchedItem.nameen;

  return `${displayValue ?? matchedItem.code}`;
};
